import ConstCommon from '../../common/Const';
import { getQueryParams } from '../../helpers/Common';
import CurrentState from '../../helpers/CurrentState';
import reducerRegistry from '../../helpers/ReducerRegistry';
import Const from './Const';
import HistoryConst from './history/Const';
import alertService from '../../../core/services/Tools/Alerts/AlertService';

export const REDUCER_NAME = 'TOOL_ALERT';
const FETCH_DATA_CHART = `${REDUCER_NAME}FETCH_DATA_CHART`;
const SET_PERSONAL_ALERT_TYPE = `${REDUCER_NAME}SET_PERSONAL_ALERT_TYPE`;
const FETCH_ALERT_HISTORY_SUCCESS = `${REDUCER_NAME}FETCH_ALERT_HISTORY_SUCCESS`;
const SET_ALERT_HISTORY_LOADING = `${REDUCER_NAME}SET_ALERT_HISTORY_LOADING`;
const UPDATE_ALERT_HISTORY = `${REDUCER_NAME}UPDATE_ALERT_HISTORY`;
const APPEND_ALERT_HISTORY = `${REDUCER_NAME}APPEND_ALERT_HISTORY`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_CURRENT_HISTORY_SEARCH = `${REDUCER_NAME}CHANGE_CURRENT_HISTORY_SEARCH`;
const CHANGE_ALERT_GROUP = `${REDUCER_NAME}CHANGE_ALERT_GROUP`;

const initialState = {
  personalAlertTypes: [],
  alertHistoryById: {},
  alertHistoryIds: [],
  isLoadingAlertHistory: true,
  totalAlertHistory: 0,
  currentHistorySearch: {},
  alertGroup: 'All',
};

const getAlertHistoryData = alertHistories => {
  const alertHistoryById = {};
  const alertHistoryIds = [];
  alertHistories.forEach(item => {
    alertHistoryById[item.notificationId] = item;
    alertHistoryIds.push(item.notificationId);
  });

  return { alertHistoryById, alertHistoryIds };
};

export const changeAlertGroup = group => ({
  type: CHANGE_ALERT_GROUP,
  payload: group,
});

export const changeCurrentHistorySearch = currentSearch => ({
  type: CHANGE_CURRENT_HISTORY_SEARCH,
  payload: currentSearch,
});

export const setAlertHistoryLoading = bool => ({
  type: SET_ALERT_HISTORY_LOADING,
  payload: bool,
});

export const fetchAlertHistory = (params, locale) => dispatch => {
  dispatch(setAlertHistoryLoading(true));
  alertService
    .getNotificationList(params)
    .then(res => {
      dispatch(setAlertHistoryLoading(false));
      const { alertHistoryById, alertHistoryIds } = getAlertHistoryData(
        res.items,
        locale,
      );

      dispatch({
        type: FETCH_ALERT_HISTORY_SUCCESS,
        payload: {
          alertHistoryById,
          alertHistoryIds,
          totalAlertHistory: res.totalCount,
        },
      });
    })
    .catch(dispatch(setAlertHistoryLoading(false)));
};

export const loadMoreAlertHistory = params => dispatch => {
  dispatch(setAlertHistoryLoading(true));
  alertService
    .getNotificationList(params)
    .then(res => {
      dispatch(updateAlertHistory(res.items));
    })
    .catch(err => dispatch(setAlertHistoryLoading(false)));
};

export const updateAlertHistory = alertHistories => {
  const { alertHistoryById, alertHistoryIds } = getAlertHistoryData(
    alertHistories,
  );

  return {
    type: UPDATE_ALERT_HISTORY,
    payload: {
      alertHistoryById,
      alertHistoryIds,
    },
  };
};

export const appendAlertHistory = alert => {
  const id = alert.notificationId || new Date().getTime();
  return {
    type: APPEND_ALERT_HISTORY,
    payload: {
      id: id || new Date().getTime(),
      data: {
        [id]: alert,
      },
    },
  };
};

export const fetchPersonalAlertTypes = () => dispatch => {
  alertService.getPersonalAlertTypes().then(res => {
    dispatch({
      type: SET_PERSONAL_ALERT_TYPE,
      payload: res.items,
    });
  });
};

export const formatParams = params => {
  params = params || {};
  const formatParams = {
    Page: params.Page || 1,
    PageSize: Const.pageSize,
  };
  if (params.OrganCode) formatParams.OrganCode = params.OrganCode;

  return formatParams;
};

export const fetchChartImage = organCode => dispatch => {
  alertService.getAlertChartImage({ OrganCode: organCode }).then(response => {
    if (response && response.items) {
      dispatch({
        type: FETCH_DATA_CHART,
        payload: {
          images: response.items.length > 0 ? response.items[0] : '',
        },
      });
    }
  });
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      const mapAlertGroup = {
        BreakoutRevenueProfit: 'BreakOut',
        FallDownRevenueProfit: 'FallDown',
        FinancialAssessment: 'FinancialAssessment',
        Ranking: 'Ranking',
        Technical: 'Technical',
        CompanyEvents: 'CompanyEvents',
        PriceVolume: 'PriceVolume',
        PersonalAlert: 'PersonalAlert',
      };

      return {
        ...state,
        ...initialState,
        alertGroup: mapAlertGroup[getQueryParams('type')] || 'All',
      };

    case UNMOUNT_COMPONENT:
      return {};

    case SET_PERSONAL_ALERT_TYPE:
      return {
        ...state,
        personalAlertTypes: action.payload,
      };

    case FETCH_ALERT_HISTORY_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isLoadingAlertHistory: false,
      };

    case UPDATE_ALERT_HISTORY:
      const { alertHistoryById, alertHistoryIds } = action.payload;
      return {
        ...state,
        alertHistoryById: {
          ...state.alertHistoryById,
          ...alertHistoryById,
        },
        alertHistoryIds: [
          ...new Set(state.alertHistoryIds.concat(alertHistoryIds)),
        ],
        isLoadingAlertHistory: false,
      };

    case SET_ALERT_HISTORY_LOADING:
      return {
        ...state,
        isLoadingAlertHistory: action.payload,
      };
    case CHANGE_ALERT_GROUP:
      CurrentState.add(
        ConstCommon.listComponent.Alerts,
        'alertGroup',
        action.payload,
      );
      return {
        ...state,
        alertGroup: action.payload,
      };
    case APPEND_ALERT_HISTORY:
      const currentHistorySearch = state.currentHistorySearch;
      const alert = action.payload.data[action.payload.id];
      const isDiffTicker =
        currentHistorySearch &&
        currentHistorySearch.ticker &&
        currentHistorySearch.ticker !== alert.ticker;
      const isNotSameAlertCode = !(
        HistoryConst.mapGroupCodes[state.alertGroup] || []
      ).includes(alert.alertCode);

      if (isDiffTicker || isNotSameAlertCode) {
        return state;
      }
      return {
        ...state,
        alertHistoryIds: [
          ...new Set([action.payload.id, ...(state.alertHistoryIds || [])]),
        ],
        alertHistoryById: {
          ...state.alertHistoryById,
          ...action.payload.data,
        },
      };

    case CHANGE_CURRENT_HISTORY_SEARCH:
      return {
        ...state,
        currentHistorySearch: action.payload,
      };

    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
